module.exports = "<router-outlet></router-outlet>\n<ng-template ngbModalContainer></ng-template>\n"


//////////////////
// WEBPACK FOOTER
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main